import {
  FileValue,
  MimeType as GrafferMimeType,
  RefkeyValueType,
} from "@graffer-inc/form-schema";
import {
  CloudGovFileRefKeyExchanger,
  RefkeyGenerator,
} from "@graffer-inc/cloud-gov-core";
import { executePreUploadFileWithMultiPart } from "../../../utils/pre-upload-file";
import { reportUnexpectedError } from "@graffer-inc/smart-apply";
import { ModifiedFile } from "../application/application-entity";

export interface FileHolder {
  files: Array<ModifiedFile>;
  formatFileURLWithRefKey?: (refKey: string) => string | null;
}

export class ModifyFileExchanger
  implements CloudGovFileRefKeyExchanger<ModifiedFile>
{
  constructor(
    private registry: { [key: string]: ModifiedFile },
    private holder: FileHolder,
  ) {}

  clearRefKey(_: string): void {
    // 訂正時は「元に戻す」操作の為に、registryにデータは残しておく
    // delete this.registry[prevRefKey];
  }

  getRegistry(): { [key: string]: ModifiedFile } {
    return {
      ...this.registry,
    };
  }

  getRegistryItems(): ModifiedFile[] {
    // 個別開発のform-schemaに未定義のファイルを引き継ぐ為に補完をする
    const customProcedureFiles = this.holder.files.filter(
      (file) => !file.refKey,
    );
    return Object.keys(this.registry)
      .map((k) => this.registry[k])
      .concat(customProcedureFiles);
  }

  async refkeyToValue(refkey: string): Promise<FileValue> {
    const file = this.registry[refkey];
    return {
      ...file,
      uri: this.holder.formatFileURLWithRefKey
        ? this.holder.formatFileURLWithRefKey(file.refKey!) || ""
        : "",
      size: file.size / 1024 / 1024,
    };
  }

  valueToRefkey(value: File, _?: string): Promise<RefkeyValueType> {
    return executePreUploadFileWithMultiPart({
      type: value.type,
      data: value,
    })
      .then((id) => {
        const refKey = RefkeyGenerator.generateUnique(
          Object.keys(this.registry),
        ); // GDKのファイルアップロードコンポーネントではアップロード済の状態からファイルのアップロードが可能（一度ファイルを削除する必要がない）な為、refKeyを常に更新する。
        this.registry = {
          ...this.registry,
          [refKey]: {
            refKey: refKey,
            name: value.name,
            size: value.size,
            type: value.type as GrafferMimeType,
            preUploadFileId: id!,
          },
        };
        return refKey;
      })
      .catch((error) => {
        reportUnexpectedError(error);
        throw error;
      });
  }
}
